import Vue from "vue";
import Router from "vue-router";
import store from "./store";
// views
import Home from "./views/DashboardSpree.vue";

Vue.use(Router);

export const router = new Router({
  mode: "history",
  linkActiveClass: "active",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
      meta: { title: "Rutschenkonfigurator Dashboard" },
    },
    {
      path: "/about",
      name: "about",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/About.vue"),
      meta: { title: "About" },
    },
    {
      path: "/login",
      name: "login",
      beforeEnter: (to, from, next) => {
        const isLoggedIn = store.getters["authentication/isLoggedIn"];
        if (typeof to.query.user !== "undefined") {
          if (isLoggedIn) {
            const name = store.getters["authentication/name"];
            if (to.query.user.toLowerCase() === name.toLowerCase()) next("/");
            else next(); // here would be the decision if user user wants to continue with new acount or stay logged in
          } else {
            next();
          }
        } else {
          if (isLoggedIn) next("/");
          else next();
        }
      },
      component: () =>
        import(/* webpackChunkName: "login" */ "./views/LoginSpree.vue"),
      meta: { title: "Login - Rutschenkonfigurator" },
    },
    {
      path: "/register",
      name: "register",
      component: () =>
        import(/* webpackChunkName: "register" */ "./views/RegisterSpree.vue"),
      meta: { title: "Register - Rutschenkonfigurator" },
    },
    {
      path: "/konfigurator",
      name: "konfigurator",
      beforeEnter: (to, from, next) => {
        const selected = store.getters["configurations/selectedConfig"];
        if (typeof selected !== "number") {
          next("/");
        } else {
          next();
        }
      },
      component: () =>
        import(/* webpackChunkName: "konfigurator" */ "./views/ConfiguratorSpree.vue"),
      // component: returnComponent,
      meta: { title: "Erstelle dein eigene Rutschenkonfiguration" },
    },
    {
      path: "/highscores",
      name: "highscores",
      component: () =>
        import(/* webpackChunkName: "highscores" */ "./views/HighTimeScores.vue"),
      meta: { title: "Rutschenhighscores" },
    },
    {
      path: "*",
      name: "notFound",
      component: () =>
        import(/* webpackChunkName: "notFound" */ "./views/NotFound.vue"),
      meta: { title: "Not Found" },
    },
  ],
});

router.beforeEach(async (to, from, next) => {
  document.title = to.meta.title;
  const isLoggedIn = store.getters["authentication/isLoggedIn"];
  const protectedRoutes = ["/", "/konfigurator", "/highscores"];
  const authRequired = protectedRoutes.includes(to.path);

  // redirect to login/home page if user wants to access protected routes if he's not logged in
  if (isLoggedIn) {
    // user is loggedIn
    const expiresAt = store.getters["authentication/expiresAt"];
    const tmpDate = Date.now();
    // check if date is valid
    if (expiresAt < tmpDate) {
      // it is expired, logout!
      await store.dispatch("authentication/logout", true);
      if (authRequired) next("/login");
      else next();
    } else if (expiresAt - tmpDate <= 43200000) {
      // token is valid for 12 hours, renew it
      await store.dispatch("authentication/renew");
      next();
    } else {
      next();
    }
  } else if (authRequired && !isLoggedIn) {
    next("/login");
  } else {
    next();
  }
});
